import React from 'react';
import PropTypes from 'prop-types';
import { FormatOptions } from './CellTypeConstants';

import Icon from '../../../components/icons/Icon';
import {
    getCurrencyDisplayName,
    getCurrencyDisplayOptions,
    getTableCurrencyList,
} from '../utils/tableCellFormattingUtils';

const CurrencyFormatOptions = (props) => {
    const { sharedFormattingValues, updateCellTypeFormat } = props;
    const { currency, currencyDisplay } = sharedFormattingValues;

    return (
        <div className="CurrencyFormatOptions celltype-format-section">
            <div className="celltype-format-title">Currency:</div>
            <div className="celltype-format-inputs">
                <div className="dropdown-container celltype-format-input">
                    <select
                        value={currency || ''}
                        onChange={(e) => updateCellTypeFormat({ [FormatOptions.CURRENCY]: e.target.value })}
                        className="dropdown"
                    >
                        <option value="" disabled>
                            Select currency
                        </option>
                        {getTableCurrencyList().map((currencyCode, i) => (
                            <option key={i} value={currencyCode}>
                                {getCurrencyDisplayName(currencyCode)} ({currencyCode})
                            </option>
                        ))}
                    </select>
                    <div className="arrow-icon-container">
                        <Icon name="dropdown-arrow" />
                    </div>
                </div>
                {currency && (
                    <div className="dropdown-container celltype-format-input">
                        <select
                            value={currencyDisplay}
                            onChange={(e) => updateCellTypeFormat({ [FormatOptions.CURRENCY_DISPLAY]: e.target.value })}
                            className="dropdown"
                        >
                            {getCurrencyDisplayOptions(currency).map((displayOption, i) => (
                                <option key={i} value={displayOption.option}>
                                    {displayOption.value}
                                </option>
                            ))}
                        </select>
                        <div className="arrow-icon-container">
                            <Icon name="dropdown-arrow" />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

CurrencyFormatOptions.propTypes = {
    sharedFormattingValues: PropTypes.object,
    updateCellTypeFormat: PropTypes.func,
};

export default CurrencyFormatOptions;
